import { createLayoutObserver } from '../../common/layout-observer/layout-observer.js';
import { getBlazeSlider } from '../../common/blaze-slider/blaze-slider-loader.js';

const initializedSliders = new WeakSet();
// Catalog HTML fields retain rendered markup. Use the existing component hook
// so saved articles receive the enhancement without being saved again.
const imageSliderSelector = '[data-analytics-component="image_slider"]:not([aria-labelledby])';

function bindImageSlider(section) {
    if (initializedSliders.has(section)) return;
    const items = [...section.querySelectorAll('figure')];
    const frames = items.map((item) => item.firstElementChild);
    if (frames.length < 2) return;
    initializedSliders.add(section);
    let activeIndex = 0;
    const track = items[0].parentElement;
    const view = section.ownerDocument.defaultView;

    const observer = createLayoutObserver(() => {
        if (!section.isConnected)
            return () => {
                observer.disconnect();
                mutations.disconnect();
            };
        const frame = frames[activeIndex] || frames[0];
        const image = frame.getBoundingClientRect();
        const bounds = section.getBoundingClientRect();
        // Captions can stretch the rail without changing the image midpoint.
        const top = image.top - bounds.top + section.scrollTop + image.height / 2;
        return () => section.style.setProperty('--z-content-slider-controls-top', `${top}px`);
    }, view);

    observer.observe(section);
    frames.forEach((frame) => observer.observe(frame));
    const refreshActiveFrame = () => {
        const slider = getBlazeSlider(track);
        const index = slider?.states[slider.stateIndex]?.page[0] ?? 0;
        if (index === activeIndex) return;
        activeIndex = index;
        observer.refresh(frames[activeIndex] || frames[0]);
    };
    section.addEventListener('zirbelino:slider-change', refreshActiveFrame);
    // Blaze's native resize refresh resets its index without a slide event.
    // Track writes only request new geometry when the active image changes.
    const mutations = new view.MutationObserver(refreshActiveFrame);
    mutations.observe(track, { attributes: true, attributeFilter: ['style'] });
    refreshActiveFrame();
}

export function initContentImageSliders(root = document) {
    if (root.matches?.(imageSliderSelector)) bindImageSlider(root);
    root.querySelectorAll?.(imageSliderSelector).forEach(bindImageSlider);
}
